/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SerieIdQueryResponse,
  GetApiV1SerieIdPathParams,
  GetApiV1SerieId401,
  GetApiV1SerieId404,
  GetApiV1SerieId500,
} from "../../types/serieRegistroController/GetApiV1SerieId.ts";

function getGetApiV1SerieIdUrl(id: GetApiV1SerieIdPathParams["id"]) {
  const res = { method: "GET", url: `/api/v1/serie/${id}` as const };
  return res;
}

/**
 * @description Retorna os dados de uma série (título/resumo no idioma corrente) e as turmas vinculadas. **(Requer Authorization para autenticação)**
 * @summary Obter série por ID (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:id}
 */
export async function getApiV1SerieId(
  id: GetApiV1SerieIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SerieIdQueryResponse,
    ResponseErrorConfig<
      GetApiV1SerieId401 | GetApiV1SerieId404 | GetApiV1SerieId500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SerieIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
